export default __webpack_public_path__ + "static/media/transform.433d8aaf.svg";